import { Percent, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
const DiscountBanner = () => {
  return <section className="py-3 px-4 bg-gradient-to-r from-blue-primary via-green-primary to-blue-primary relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-primary/90 via-green-primary/90 to-blue-primary/90"></div>
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 bg-white/95 backdrop-blur-sm rounded-lg p-3 md:p-4 shadow-lg">
          <div className="flex items-center gap-3 text-center sm:text-left">
            <div className="p-1.5 bg-gradient-to-r from-blue-primary to-green-primary rounded-full shrink-0">
              <Percent className="text-white" size={18} />
            </div>
            <div>
              <span className="text-xl font-bold bg-gradient-to-r from-blue-primary to-green-primary bg-clip-text text-transparent">
                15% OFF
              </span>
              <span className="text-sm text-gray-600 ml-2">all DNA testing services</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1 text-blue-primary mr-2">
              <Clock size={14} />
              <span className="font-semibold text-xs">Limited time</span>
            </div>
            <Button 
              size="sm" 
              className="bg-gradient-to-r from-blue-primary to-green-primary hover:from-blue-primary/90 hover:to-green-primary/90 text-white font-bold shadow-lg group" 
              onClick={() => window.location.href = '/booking'}
              aria-label="Claim your 15% discount and schedule DNA test"
            >
              Claim Discount
              <ArrowRight className="ml-1 group-hover:translate-x-1 transition-transform duration-200" size={14} />
            </Button>
          </div>
        </div>
      </div>
    </section>;
};
export default DiscountBanner;